

















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { ScheduleCommentState } from '@/store/scheduleComment/types'
import { mbSubstr, mbStrlen } from '@/utils/string'
import { EventEmitter } from 'events'

const enum EventTypes {
  CONFIRM_DONE
}

const enum ConfirmModalReactTypes {
  OK,
  CANCEL
}

@Component({
  components: {
    ConfirmModal: () => import('@/components/common/modals/AlertModal.vue')
  }
})
export default class Comment extends Vue {
  @Prop(Object) readonly comment!: ScheduleCommentState & { content: string }

  readonly CONTENT_LIMIT_LENGTH = 400
  $store!: ExStore
  showAllContent = false
  deletePending = false
  showConfirmModal = false
  events = new EventEmitter()

  get date() {
    return dayjs(this.comment.commentDatetime).format('M月D日 HH:mm')
  }

  get worker() {
    return this.$store.getters['worker/workersById']([this.comment.worker])[0]
  }

  get content() {
    return this.showAllContent
      ? this.comment.content
      : mbSubstr(this.comment.content, 0, this.CONTENT_LIMIT_LENGTH)
  }

  get isHideText() {
    return mbStrlen(this.comment.content) > this.CONTENT_LIMIT_LENGTH
  }

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  get isOwnComment() {
    return this.comment.worker === this.loginUser.id
  }

  handleClickShowMore() {
    this.showAllContent = true
  }

  handleClickClose() {
    this.showAllContent = false
  }

  handleClickReply() {
    this.$emit('clickReply')
  }

  async handleClickDeleteOwnComment() {
    if (this.deletePending) {
      return
    }
    try {
      this.deletePending = true
      this.showConfirmModal = true

      const result = await new Promise(resolve =>
        this.events.once(EventTypes.CONFIRM_DONE, resolve)
      )

      this.showConfirmModal = false

      if (result === ConfirmModalReactTypes.CANCEL) {
        return
      }

      const commentId = this.comment.id
      await this.$store.dispatch('scheduleComment/deleteScheduleComment', {
        commentId
      })
    } catch (error) {
      console.error(error)
    } finally {
      this.deletePending = false
    }
  }

  handleConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DONE, ConfirmModalReactTypes.OK)
  }

  handleConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DONE, ConfirmModalReactTypes.CANCEL)
  }
}
